import { Tabs, Tab } from 'react-bootstrap';
import UserStatusPopoverContent from '../UserStatus/UserStatusPopoverContent';
import UserWithDetailsPopoverContent from '../UserWithDetails/UserWithDetailsPopoverContent';
import './UserStatusWithDetailsPopoverContent.scss';

export default function UserStatusWithDetailsPopoverContent({
  user,
  currentUser,
  course,
  history,
  selectShowCourseDashboard,
  setShowUserLevelModal,
  setShowUserExtensionActionHistoryModal,
  breadCrumb,
  setPortfolioBreadCrumb,
  updateUserProfile,
}) {
  return (
    <Tabs
      id="user-status-popover-wrapper"
      className="user-status-with-details-popover-content"
    >
      <Tab title="Status" eventKey={1}>
        <UserStatusPopoverContent
          user={user}
          currentUser={currentUser}
          updateUserProfile={updateUserProfile}
        />
      </Tab>
      <Tab title="Details" eventKey={2}>
        <UserWithDetailsPopoverContent
          userId={user._id}
          username={user.username}
          user={user}
          course={course}
          history={history}
          selectShowCourseDashboard={selectShowCourseDashboard}
          setShowUserLevelModal={setShowUserLevelModal}
          setShowUserExtensionActionHistoryModal={
            setShowUserExtensionActionHistoryModal
          }
          breadCrumb={breadCrumb}
          setPortfolioBreadCrumb={setPortfolioBreadCrumb}
        />
      </Tab>
    </Tabs>
  );
}
